import React, { useEffect, useState, useCallback } from "react";
import { Bell } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { ROLE_HOME } from "@/lib/nav";

const POLL_MS = 60000;

// Bell badge: asks only for the unread COUNT (the list loads on the Notifications page). Checks every 60 s while
// the tab is visible, plus right away on navigation, when the tab comes back, and when another screen marks items read.
export function NotificationDrawer() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [unread, setUnread] = useState(0);

  const load = useCallback(async () => {
    if (document.hidden) return;
    try {
      const { data } = await api.get("/notifications/unread-count");
      setUnread(data.count || 0);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { load(); }, [load, pathname]);

  useEffect(() => {
    const t = setInterval(load, POLL_MS);
    document.addEventListener("visibilitychange", load);
    window.addEventListener("rpg:badges-refresh", load);
    return () => {
      clearInterval(t);
      document.removeEventListener("visibilitychange", load);
      window.removeEventListener("rpg:badges-refresh", load);
    };
  }, [load]);

  return (
    <Link
      to={`${ROLE_HOME[user.role] || "/member/dashboard"}#notifications`}
      data-testid="notification-drawer-trigger"
      className="relative flex h-10 w-10 items-center justify-center rounded-full text-slate-600 hover:bg-slate-100 transition-colors"
      title="Notifications"
    >
      <Bell className="h-5 w-5" />
      {unread > 0 && (
        <span
          data-testid="notification-unread-badge"
          className="absolute -top-0.5 -right-0.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white animate-badge-pulse"
        >
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </Link>
  );
}

export default NotificationDrawer;
